var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup49793(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49793",
    "data-name": "Group 49793",
    transform: "translate(-431 -412)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 38,
    cy: 38,
    r: 38,
    transform: "translate(431 412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_49794",
    "data-name": "Group 49794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49791",
    "data-name": "Group 49791",
    transform: "translate(4.719 -0.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M38.7,0a9.846,9.846,0,0,1,9.7,9.7A9.7,9.7,0,1,1,29,9.7,9.846,9.846,0,0,1,38.7,0Z",
    transform: "translate(425.881 433.359)",
    fill: "#1d1d1b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M34.593,94.347H0C1.572,78.884,33.021,78.884,34.593,94.347Z",
    transform: "translate(447.281 372.295)",
    fill: "#1d1d1b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M132.233,61.853h2.621V59.233a.919.919,0,1,1,1.834,0v2.621h2.621a.919.919,0,1,1,0,1.834h-2.621v2.621a.919.919,0,1,1-1.834,0V63.688h-2.621A.919.919,0,1,1,132.233,61.853Z",
    transform: "translate(348.428 388.374)",
    fill: "#1d1d1b",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup49793);
export default __webpack_public_path__ + "static/media/Group 49793.2e6515e31e5cf5caa85ad5b341f5ec62.svg";
export { ForwardRef as ReactComponent };